/**
 * Keepa - Amazon Price Tracker
 *
 * One static resource, scoped to Amazon's storefront domains. Only Amazon can detect
 * it — which matters, since Keepa exists to surface price history Amazon does not show.
 * Manifest verified against version 5.62.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'neebplgakaahbhdphmkckjjcegoiijjo';
export const keepa: ExtensionDefinition = {
  id: ID,
  name: 'Keepa - Amazon Price Tracker',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 4_000_000,
  requiredOrigin: 'https://www.amazon.com',
  notes:
    'Scoped to Amazon domains, so Amazon — and only Amazon — can identify visitors ' +
    'running a price tracker.',
  signals: [
    { id: 'war-selection-hook', kind: 'web-accessible-resource',
      description: 'Fetch selectionHook.js — its only static resource, exposed to Amazon domains.',
      weight: 1, run: () => probeFetch(ID, 'selectionHook.js') },
  ],
};
